module.exports = __webpack_public_path__ + "static/media/menu_mobile.0cd82a96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Menu/menu_mobile.svg
// module id = 104
// module chunks = 0